import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './OTPInput.module.css';

const OTPInput = ({ numInputs = 4, onComplete, autoFocus = true }) => {
  const [otp, setOtp] = useState(Array(numInputs).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (autoFocus) {
      inputRefs.current[0].focus();
    }
  }, [autoFocus]);

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^\d$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
  
      // Check if the inputRefs and the next input are defined before calling focus
      if (value !== "" && index < numInputs - 1 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
  
      if (newOtp.every(digit => digit !== "")) {
        onComplete(newOtp.join(""));
      }
    }
  };
  

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <div className={styles["otp-container"]}>
      <div className={styles["otp-inputs"]}>
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className={styles["otp-input"]}
            autoFocus={autoFocus && index === 0}
            aria-label={`OTP input ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

OTPInput.propTypes = {
  numInputs: PropTypes.number,
  onComplete: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
};

export default OTPInput;
